import { ComponentType } from 'react';
import { PlayfulThemeId } from '@/styles/playful/identifiers';
import SpaceMascot from './SpaceMascot';
import OceanMascot from './OceanMascot';
import JungleMascot from './JungleMascot';
import CandyMascot from './CandyMascot';
import { RobotMascot } from './RobotMascot';
import { MagicMascot } from './MagicMascot';
import { DoodleMascot } from './DoodleMascot';

export interface MascotProps {
  style?: React.CSSProperties;
  className?: string;
}

export const MASCOT_COMPONENTS: Record<string, ComponentType<MascotProps>> = {
  [PlayfulThemeId.SPACE]: SpaceMascot,
  [PlayfulThemeId.OCEAN_WAVES]: OceanMascot,
  [PlayfulThemeId.JUNGLE]: JungleMascot,
  [PlayfulThemeId.CANDY]: CandyMascot,
  [PlayfulThemeId.ROBOT]: RobotMascot,
  [PlayfulThemeId.MAGIC]: MagicMascot,
  [PlayfulThemeId.DOODLE]: DoodleMascot,
};

export {
  SpaceMascot,
  OceanMascot,
  JungleMascot,
  CandyMascot,
  RobotMascot,
  MagicMascot,
  DoodleMascot,
};
